// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"77ebb019","169":"9273cbe4","351":"271405d3","378":"b94b348e","530":"6002055c","676":"3b634a37","737":"abfe2a7c","780":"7cca32f5","841":"8057c832","842":"1cac5f23","849":"6cebe03f"}[chunkId] + ".chunk.js";
};